import React, { useEffect, useState } from "react";

const ValidPasswordInput = ({ password, setPassword }) => {
  const [rawPassword, setRawPassword] = useState(password);
  const [requirements, setRequirements] = useState([]);

  // Validate password
  useEffect(() => {
    const errors = validatePassword(rawPassword);
    setRequirements(errors);
    if (!errors.length) setPassword(rawPassword);
    else setPassword("");
  }, [rawPassword, setPassword]);

  const validatePassword = (password) => {
    const errors = [];
    if (password.length < 8)
      errors.push("Le mot de passe doit comporter au moins 8 caractères.");
    if (!/[a-z]/.test(password))
      errors.push(
        "Le mot de passe doit contenir au moins une lettre minuscule."
      );
    if (!/[A-Z]/.test(password))
      errors.push(
        "Le mot de passe doit contenir au moins une lettre majuscule."
      );
    if (!/[0-9]/.test(password))
      errors.push("Le mot de passe doit contenir au moins un chiffre.");
    return errors;
  };

  const handleChange = (e) => {
    const value = e.target.value;

    setRawPassword(value);
  };

  return (
    <div className="d-flex flex-column">
      <input
        type="password"
        id="rawPassword"
        className={`form-control ${
          requirements.length > 0 ? "is-invalid" : "is-valid"
        }`}
        value={rawPassword}
        onChange={handleChange}
      />
      <div className="feedback">
        <ul className="mb-0">
          {requirements.map((req, index) => (
            <li key={index}>{req}</li>
          ))}
        </ul>
      </div>
      {requirements.length === 0 && rawPassword && (
        <div className="valid-feedback">Le mot de passe rempli tous les critères.</div>
      )}
    </div>
  );
};

export default ValidPasswordInput;
